import { useState, useEffect } from "react";
import { Button, Modal, message } from "antd";

import dataJson from "@/../public/data.json";
import { isEmpty } from "lodash-es";

import VerifyImg from "@/components/verify";


interface IProps {
  phoneNumber: string;
  width?: number;
  height?: number;
  fontSize?: number;
  reqData?: any;
  beforeClick?: ((e?: any) => any) | boolean;
  apiFnc: (e: any) => any;
  reload: (e: any) => void;
}

const VerifyCodeBtn = (props: IProps) => {
  const { login, req_err } = dataJson;
  const { phoneNumber, apiFnc, width = 132, height = 56, fontSize, reqData, reload, beforeClick } = props;

  const [codeRestTime, setCodeRestTime] = useState(180);
  const [flag, setFlag] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const verifyCheckEnd = (params: any) => {
    setIsModalOpen(false);
    if (typeof beforeClick == "boolean") {
      getCode(params);
    } else {
      beforeClick!(params).then(() => getCode(params));
    }
  };

  const getCode = async (params?: any) => {
    const res: any = await apiFnc(
      reqData !== undefined
        ? reqData
        : {
            receiver: phoneNumber,
            validate: {
              type: params?.type,
              token: params?.token,
            },
          }
    ); // reqData可能是null或对象，只能判断不等了undefined
    if (res.code === 200) {
      reload({ ...res.data, isFirst: false });
      setFlag(true);
      isFirst && setIsFirst(false);
    } else {
      window.message.error(res.msg || req_err);
    }
  };
  const btnClick = async () => {
    if (isEmpty(phoneNumber)) return;

    if (beforeClick) {
      setIsModalOpen(true);
    } else {
      getCode();
    }
  };

  useEffect(() => {
    if (!flag) return;
    const timer = setInterval(() => {
      setCodeRestTime((data) => {
        data--;
        if (data === 0) {
          clearInterval(timer);
          setFlag(false);
          setCodeRestTime(180);
        }
        return data;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [flag]);

  return (
    <>
      <Button
        size="large"
        disabled={flag}
        style={{
          width: width,
          height: height,
          fontSize: fontSize ? fontSize : "",
          paddingInline: 0,
          color: flag ? "#0A59F7" : "rgba(0,0,0,0.6)",
          borderColor: flag ? "#0A59F7" : "rgba(0,0,0,0.2)",
        }}
        onClick={btnClick}
        className="verify-codeBtn"
      >
        {flag ? `${login.get_code}${codeRestTime}s` : isFirst ? login.get_code : login.get_code_again}
      </Button>
      <Modal
        title={login.place_validator}
        footer={null}
        width={358}
        destroyOnClose
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <VerifyImg verifyCheckEnd={verifyCheckEnd} />
      </Modal>
    </>
  );
};

export default VerifyCodeBtn;
